import { render } from "./PhasesComponent.vue?vue&type=template&id=4c4eb88f&scoped=true"
import script from "./PhasesComponent.vue?vue&type=script&lang=js"
export * from "./PhasesComponent.vue?vue&type=script&lang=js"

import "./PhasesComponent.vue?vue&type=style&index=0&id=4c4eb88f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4eb88f"]])

export default __exports__